import React from 'react'
import { Link } from 'react-router-dom'
import SuperUserPageSF from './SuperUserPageSF'

const SuperUserSettingsPageUI = ({ context, className,
  topnav, backLink, headerText, subHeaderText,
  dimension, centered, children, page
}) =>
  <SuperUserPageSF
    context={context}
    className={className}
    topnav={topnav}
    backLink={backLink}
    headerText={headerText}
    subHeaderText={subHeaderText}
    dimension={dimension}
    centered={centered}
    children={children}
    sideBar={
      <SideBarUI
        page={page}
      />
    }
  />

const SideBarUI = ({ page }) =>
  <div className='t_sidebar'>
    <SideBarItemUI label='Settings' to='/su/settings' active={page === 'settings'} />
    <SideBarItemUI label='Loan types' to='/su/loanTypes' active={page === 'loanTypes'} />
    {/* <SideBarItemUI label='Score Metadata' to='/su/scoreMetadata' /> */}
    <SideBarItemUI label='Properties' to='/su/properties' active={page === 'properties'} />
    <SideBarItemUI label='Bank analyzer keywords' to='/su/mappings/bank_analyzer_keywords' active={page === 'baKeywords'} />
    <SideBarItemUI label='Document Templates' to='/su/docTemplates' active={page === 'docTemplates'} />
    <SideBarItemUI label='Support Templates' to='/su/supportTemplates' active={page === 'supTemplates'} />
    <SideBarItemUI label='Master Template' to='/su/master/termSheet/general' active={page === 'ftlTemplate'} />
    <SideBarItemUI label='Compliance Listing' to='/su/complianceListing' active={page === 'complianceListing'} />  {/* New Compliance Listing item */}
    <SideBarItemUI label='Vendor bill COAs' to='/su/vendorPaymentCOAs' active={page === 'vbCOAs'} />
    {/*
      !user.identityProvider &&s
      <SideBarItemUI label='Change password' to='/su/password' />
    */}
    <SideBarItemUI label='Users' to='/su/users' active={page === 'users'} />
    <SideBarItemUI label='Developer' to='/su/testdata' active={page === 'developer'} />
    {/* <SideBarItemUI label='Events' to='/su/events' active={page === 'events'} /> New Events item */}
    {/* <SideBarItemUI label='Loan Type and Event Mapping' to='/su/loanTypeAndEventMapping' active={page === 'loanTypeAndEventMapping'} /> {/* New Events item */}
    {/* <SideBarItemUI label='WhatsApp Template' to='/su/whatsappTemplate' active={page === 'whatsappTemplate'} /> New WhatsApp Template item list */}
    <SideBarItemUI label='Prior & Post Config' to='/su/priorDaysConfig' active={page === 'priorDaysConfig'} /> {/* New Prior Days Config item list */}
    <SideBarItemUI label='Onboarding Events Config' to='/su/onboarding-events' active={page === 'onboarding-events'} /> {/* New Onboarding Events Config item list */}
  </div>

const SideBarItemUI = ({ label, to, active }) =>
  <Link to={to} className={`${active ? 'active' : ''} t_sidebar_item`}>
    {label}
  </Link>

export default SuperUserSettingsPageUI

